export default __webpack_public_path__ + "static/media/vibrant-gujarat-2018.7aecb5b2.jpg";